import {useMemo} from 'react';

import {LlmProxyClient} from './LlmProxyClient';

const LLM_PROXY_PATH = '/llm_proxy';

const resolveLlmProxyBaseUrl = () => {
  // This serves as a bridge between the libraries. Since the weave package
  // cannot depend on the app package, we reference the same global variable
  const configBaseUrl = (window as any)?.CONFIG?.TRACE_BACKEND_BASE_URL;
  if (configBaseUrl) {
    return configBaseUrl + LLM_PROXY_PATH;
  }
  return null;
};

export const useLLMProxyClient = (entity?: string, project?: string) => {
  const maybeBaseUrl = resolveLlmProxyBaseUrl();
  return useMemo(() => {
    if (!entity || !project || !maybeBaseUrl) {
      return null;
    }
    return new LlmProxyClient({baseUrl: maybeBaseUrl, entity, project});
  }, [maybeBaseUrl, entity, project]);
};
